import React from 'react'

const HomePage = () => {
  return (
    <div>SDK HomePage</div>
  )
}

export default HomePage